import axios from "axios";
import { baseUrl } from "../config/api-config";

export const createTask = (data, token) => axios.post(`${baseUrl}/task`, data, {
    headers: {
        authorization: token
    }
})

export const deleteTask = (id, token) => axios.delete(`${baseUrl}/task/${id}`, {
    headers: {
        authorization: token
    }
})

export const updateTask = (id, data, token) => axios.patch(`${baseUrl}/task/${id}`, data, {
    headers: {
        authorization: token
    }
})

export const updateTaskBudget = (data, token) => axios.patch(`${baseUrl}/task-budget`, data, {
    headers: {
        authorization: token
    }
})

export const getTaskById = (id, token) => axios.get(`${baseUrl}/task/${id}`, {
    headers: {
        authorization: token
    }
})

